import React from 'react';
import { string, object } from 'prop-types';

import Icon from 'foundations/Icons/Icon';
import styles from '../LandingSkinnyBanner.css';

const SkinnyItem = ({ icon, description }) => (
  <div className={styles.item}>
    <Icon customClasses={styles.icon} {...icon} responsive />
    <p className={styles.itemDescription}>{description}</p>
  </div>
);

SkinnyItem.propTypes = {
  icon: object,
  description: string,
};

SkinnyItem.displayName = 'SkinnyItem';

export default SkinnyItem;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/SkinnyBanner/Landing/SkinnyItem/SkinnyItem.js